import WhiteboardStore from "./WhiteboardStore";

const whiteboardStoreList = [{ name: "whiteboardStore", store: WhiteboardStore }];

export default whiteboardStoreList;
